/* eslint-disable arrow-parens */
import { defaultClient as apolloClient } from '@/plugins/vue-apollo';
import { GET_STATIC_TEAMS_GQL, GET_STATIC_TEAM_GQL } from '@/graphql/static-queries.gql';

const initTeam = {
  id: '',
  title: 'Team Title',
  slug: '',
  color: '#cccccc',
  icon: '',
};

export default {
  namespaced: true,

  state: {
    // = data
    staticTeam: Object.assign({}, initTeam),
    staticTeams: [],
  },

  mutations: {
    SET_STATIC_TEAM(state, payload) {
      state.staticTeam = payload;
    },
    SET_STATIC_TEAMS(state, payload) {
      state.staticTeams = payload;
    },
  },

  actions: {
    getStaticTeams({ commit }) {
      apolloClient
        .query({ query: GET_STATIC_TEAMS_GQL })
        .then(({ data }) => {
          commit('SET_STATIC_TEAMS', data.staticTeams);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    getStaticTeam({ commit }, payload) {
      commit('shared/SET_LOADING_CHILD', true, { root: true });

      apolloClient
        .query({
          query: GET_STATIC_TEAM_GQL,
          variables: payload,
        })
        .then(({ data }) => {
          commit('SET_STATIC_TEAM', data.staticTeam);
          commit('shared/SET_LOADING_CHILD', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING_CHILD', false, { root: true });
        });
    },
    resetStaticTeam({ commit }) {
      commit('SET_STATIC_TEAM', Object.assign({}, initTeam));
    },
  },

  getters: {
    // = computed properties
    staticTeam: state => state.staticTeam,
    staticTeams: state => state.staticTeams,
  },
};
